module.exports = __webpack_public_path__ + "img/chang-name.2.76d15a6a.svg";